import React, { useState, useEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import Modal from '../modal/modal.component';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import { signOutStart } from '../../redux/user/user.actions';
const SessionTimeout = ({ currentUser, dispatchSignOutStart }) => {
  const [events] = useState(['click', 'scroll']);
  const [second, setSecond] = useState(0);
  const [isOpen, setOpen] = useState(false);

  //   let timeStamp;
  let warningInactiveInterval = useRef();
  let startTimerInterval = useRef();

  // warning timer
  let warningInactive = useCallback(
    (timeString) => {
      clearTimeout(startTimerInterval.current);

      warningInactiveInterval.current = setInterval(() => {
        const maxTime = 5; // ? Maximum idle time given before logout (minutes)
        const popTime = 4; // ? Remaining time (notification) left to logout.

        const diff = moment.duration(moment().diff(moment(timeString)));
        const minPast = diff.minutes();
        const leftSecond = 60 - diff.seconds();
        // console.log(
        //   'Inactive for : ' +
        //     minPast +
        //     ' minutes ' +
        //     +diff.seconds() +
        //     'seconds'
        // );
        if (minPast === popTime) {
          //   console.log('Opening Timeout Modal');
          setSecond(leftSecond);
          setOpen(true);
        }

        if (minPast === maxTime) {
          clearInterval(warningInactiveInterval.current);
          setOpen(false);
          sessionStorage.removeItem('lastTimeStamp');
          if (currentUser) {
            dispatchSignOutStart();
          }
        }
      }, 1000);
    },
    [dispatchSignOutStart, currentUser]
  );
  // start inactive check
  let timeChecker = useCallback(() => {
    startTimerInterval.current = setTimeout(() => {
      let storedTimeStamp = sessionStorage.getItem('lastTimeStamp');

      if (storedTimeStamp) {
        // console.log('Starting Inactive Tracker');
        warningInactive(storedTimeStamp);
      }
    }, 6000);
  }, [warningInactive]);

  // reset interval timer
  let resetTimer = useCallback(() => {
    clearTimeout(startTimerInterval.current);
    clearInterval(warningInactiveInterval.current);
    // console.log('Resetting session timeout');
    // console.log('Current User : ' + currentUser);
    if (currentUser !== null) {
      let timeStamp = moment().format();
      sessionStorage.setItem('lastTimeStamp', timeStamp);
      // console.log(timeStamp);
      // console.log('Starting TimeChecker');
      timeChecker();
    } else {
      clearInterval(warningInactiveInterval.current);
      sessionStorage.removeItem('lastTimeStamp');
    }

    setOpen(false);
  }, [currentUser, timeChecker]);

  // handle close popup
  const handleClose = () => {
    setOpen(false);
    resetTimer();
  };

  useEffect(() => {
    // console.log(getEventListeners());
    if (currentUser === null) {
      window.removeEventListener('click', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      clearTimeout(startTimerInterval.current);
      resetTimer();
      return;
    }
    events.forEach((event) => {
      // console.log('Adding Listner for event: ' + event);
      window.addEventListener(event, resetTimer);
    });
  }, [events, resetTimer, currentUser]);

  useEffect(() => {
    timeChecker();

    return () => {
      clearTimeout(startTimerInterval.current);
      resetTimer();
    };
  }, [resetTimer, timeChecker]);

  if (!isOpen) {
    return null;
  }

  // change fragment to modal and handleclose func to close
  return (
    <Modal
      modalOpen={isOpen}
      handleClose={handleClose}
      text={`You will be logged out in ${second} seconds`}
      type="dropIn"
    />
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSignOutStart: () => dispatch(signOutStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeout);
